import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import Button from "components/atoms/button";

const StoryBlock = ({ stories }) => {
  if (!stories?.length) {
    return null;
  }

  return (
    <div className="stories-block">
      <div className="container">
        <div className="content">
          <h5>Historias Usados</h5>
        </div>
      </div>
      <div className="stories-scroll">
        <div className="stories-container">
          {stories.map((story) => (
            <div className="story" key={story.id}>
              <Link to={story.slug_url}>
                <div className="story-data">
                  <h4>{story.title}</h4>
                  <div className="story-data-action">
                    <Button
                      buttonText="Ver historia completa"
                      block
                      type="secondary"
                    />
                  </div>
                </div>
                <div className="story-video-preview">
                  <video
                    autoPlay
                    muted
                    loop
                    onMouseOver={(event) => event.target.play()}
                    onMouseOut={(event) => event.target.pause()}
                  >
                    <source
                      src={`https://territorioyacopini.com.ar/${story.video_path}`}
                      type="video/mp4"
                    />
                  </video>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoryBlock;
